import { DateField, NumberField, Show, SimpleShowLayout, TextField } from "react-admin";

export const AwsFilesShow = props => (
    <Show {...props}>
        <SimpleShowLayout>
        <TextField source="key" />
            <DateField source="LastModified" />
            <TextField source="ETag" />
            <NumberField source="ContentLength" />
            {/* <TextField source="StorageClass" /> */}
        </SimpleShowLayout>
    </Show>
);